import  { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationSettings from './Components/NotificationSettings';
import TeamNglMessages from './Components/TeamNglMessages';
import HiddenWords from './Components/HiddenWords';
import PauseLink from './Components/PauseLink';
import SafetyScreen from './Components/SafetyScreen';
import Filtering from './Components/Filtering';
import HelpScreen from './Components/HelpScreen';
import CustomAppBar from '../../mainComponents/appBar';
import { FaBell, FaChevronRight, FaCogs, FaHeart, FaInfo, FaPause, FaQuestionCircle, FaSearch, FaShieldAlt, FaStopCircle, FaTrash, FaUser } from 'react-icons/fa';
import UpdateProfilePicture from './Components/UpdateprofilePicture';

export default function SettingsScreen() {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const settingsSections = [
    {
      title: 'Preferences',
      icon: '💫',
      items: [
        {
          label: 'Update Profile Picture',
          icon: <FaUser className="w-3 h-4" />,
          route: '/settings/updatepicture',
          Component: <UpdateProfilePicture />,
        },
        {
          label: 'Notifications',
          icon: <FaBell className="w-4 h-4" />,
          route: '/settings/notifications',
          Component: <NotificationSettings />,
        },
        {
          label: 'Team broChat messages',
          icon: <FaHeart className="w-4 h-4" />,
          route: '/settings/team-message',
          Component: <TeamNglMessages />,
        },
      ],
    },
    {
      title: 'Safety controls',
      icon: '🦺',
      items: [
        {
          label: 'Hidden words',
          icon: <FaSearch className="w-4 h-4 " />,
          route: '/settings/hidden-words',
          Component: <HiddenWords />,
        },
        {
          label: 'Blocked users',
          icon: <FaStopCircle className="w-4 h-4" />,
          route: '/settings/blocked-users',
          Component: <HiddenWords />,
        },
        {
          label: 'Pause my link',
          icon: <FaPause className="w-4 h-4" />,
          route: '/settings/pause-link',
          Component: <PauseLink />,
        },
        {
          label: 'Advanced message filtering',
          icon: <FaCogs className="w-4 h-4" />,
          route: '/settings/filtering',
          Component: <Filtering />
        },
      ],
    },
    {
      title: 'More',
      icon: '✴️',
      items: [
        {
          label: 'I need help',
          icon: <FaQuestionCircle className="w-4 h-4" />,
          route: '/settings/help',
          Component: <HelpScreen />
        },
        {
          label: 'Safety resources',
          icon: <FaShieldAlt className="w-4 h-4" />,
          route: '/settings/safety-resources',
          Component: <SafetyScreen />
        },
        {
          label: 'Terms of use',
          icon: <FaInfo className="w-4 h-4" />,
          route: '/settings/terms',
          Component: <SafetyScreen />
        },
        {
          label: 'Delete account',
          icon: <FaTrash className="w-4 h-4 text-red-600" />,
          isDanger: true,
          onClick: () => setShowDeleteModal(true)
        }
      ],
    },
  ];

  return (
    <div className="flex flex-col items-center justify-between pt-10 h-screen no-scrollbar bg-[#f8f9fa] text-white p-5 font-custom">
      <div className="w-full max-w-sm bg-[#f8f9fa] text-black">
        <CustomAppBar title="Settings" backgroundColor="#f8f9fa" />

        <div className="mt-6 space-y-6 no-scrollbar overflow-y-auto max-h-[calc(100vh-150px)]">
          {settingsSections.map((section, i) => (
            <div key={i}>
              <div className="text-gray-500 text-sm font-semibold mb-2 flex items-center space-x-2">
                <span>{section.icon}</span>
                <span>{section.title}</span>
              </div>
              <div className="bg-[#eef2f3] rounded-2xl p-2 space-y-2">
                {section.items.map((item, j) => (
                  <div
                    key={j}
                    onClick={() => item.onClick ? item.onClick() : navigate(item.route)}
                    className="flex items-center justify-between bg-white rounded-2xl p-3 cursor-pointer hover:bg-gray-100 transition"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="bg-gray-100 rounded-full p-2">
                        {item.icon}
                      </div>
                      <span className={`font-semibold text-[16px] ${item.isDanger ? 'text-red-600' : ''}`}>
                        {item.label}
                      </span>
                    </div>
                    <FaChevronRight className="size-3" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-lg w-[90%] max-w-xs p-6 text-center">
            <div className="mb-4">
              <h2 className="text-lg font-bold text-black">Are you sure?</h2>
              <p className="text-sm text-gray-600 mt-1">
                If you delete your account, you will lose access to your username and all messages.
              </p>
            </div>
            <div className="flex items-center justify-between">
              <button
                className="bg-gray-200 text-black text-sm font-semibold rounded-full px-5 py-2 w-[45%]"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white text-sm font-semibold rounded-full px-5 py-2 w-[45%]"
                onClick={() => {
                  // Delete logic goes here
                  setShowDeleteModal(false);
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}
